// src/features/release-notes/api.ts
//
// The three reads/writes, through the app's authenticated client (token, impersonation header). The
// client is loaded on first use so the shell does not pull it in just to mount the prompt.

import type { ManualLang } from '@/features/manual/types';
import type { ReleaseNote } from './types';

const client = () => import('@/providers/dataProvider').then((m) => m.default);

export const releaseNotesApi = {
  pending: async (lang: ManualLang): Promise<ReleaseNote[]> => (await client()).getPendingReleaseNotes(lang),
  history: async (lang: ManualLang): Promise<ReleaseNote[]> => (await client()).getReleaseNotes(lang),
  markSeen: async (ids: string[]): Promise<void> => (await client()).markReleaseNotesSeen(ids),
};
